import React, { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styled, { keyframes } from "styled-components";
import { AuthContext } from "../context/AuthContext";
import axios from "axios";

const FreshPassport = () => {
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  const [currentStep, setCurrentStep] = useState(1);

  const [formData, setFormData] = useState({
    name: "",
    contactNo: "",
    emergencyContact: "",
    education: "",
    profession: "",
    placeOfBirth: "",
    policeStation: "",
    motherName: "",
    fatherName: "",
    spouseName: "",
    aadhaarFile: null,
    panFile: null,
    marksheetfile: null,
  });

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: files ? files[0] : value,
    }));
  };
  useEffect(() => {
    const checkExisting = async () => {
      if (!user?.email) return;
      try {
        const res = await axios.get(
          `http://localhost:5000/api/fresh-passport/check/${user.email}`
        );
        if (res.data.limitReached) {
          alert("You have already submitted 5 applications. Limit reached.");
          navigate("/UserProfile");
        }
      } catch (err) {
        console.error("Error checking existing applications:", err);
      }
    };
    checkExisting();
  }, [user]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!user?.email) {
      alert("Login required to submit");
      return;
    }

    const data = new FormData();
    Object.entries(formData).forEach(([key, value]) => {
      data.append(key, value);
    });
    data.append("email", user.email);

    try {
      const res = await axios.post(
        "http://localhost:5000/api/fresh-passport",
        data
      );
      if (res.status === 201) {
        alert(`Application Submitted! ID: ${res.data.applicationId}`);
        navigate("/Payments");
      }
    } catch (err) {
      alert("Submission failed");
      console.error(err);
    }
  };

  return (
    <Container>
      <h1>Fresh Passport Application</h1>
      <Progress>Step {currentStep} of 2</Progress>
      <form onSubmit={handleSubmit}>
        {currentStep === 1 && (
          <>
            <h2>Step 1: Personal Info</h2>
            <Label>Full Name</Label>
            <Input type="text" name="name" required onChange={handleChange} />

            <Label>Contact Number</Label>
            <Input
              type="text"
              name="contactNo"
              required
              onChange={handleChange}
            />

            <Label>Emergency Contact</Label>
            <Input
              type="text"
              name="emergencyContact"
              required
              onChange={handleChange}
            />

            <Label>Education</Label>
            <Input
              type="text"
              name="education"
              required
              onChange={handleChange}
            />

            <Label>Profession</Label>
            <Input
              type="text"
              name="profession"
              required
              onChange={handleChange}
            />

            <Label>Place of Birth</Label>
            <Input
              type="text"
              name="placeOfBirth"
              required
              onChange={handleChange}
            />

            <Button type="button" onClick={() => setCurrentStep(2)}>
              Next
            </Button>
          </>
        )}

        {currentStep === 2 && (
          <>
            <h2>Step 2: Documents & Family Info</h2>

            <Label>Police Station</Label>
            <Input
              type="text"
              name="policeStation"
              required
              onChange={handleChange}
            />

            <Label>Aadhaar Card</Label>
            <Input
              type="file"
              name="aadhaarFile"
              required
              onChange={handleChange}
            />

            <Label>PAN Card</Label>
            <Input
              type="file"
              name="panFile"
              required
              onChange={handleChange}
            />

            <Label>Marksheet / Birth Certificate</Label>
            <Input type="file" name="marksheetfile" onChange={handleChange} />

            <Label>Mother's Name</Label>
            <Input
              type="text"
              name="motherName"
              required
              onChange={handleChange}
            />

            <Label>Father's Name</Label>
            <Input
              type="text"
              name="fatherName"
              required
              onChange={handleChange}
            />

            <Label>Spouse's Name</Label>
            <Input type="text" name="spouseName" onChange={handleChange} />

            <Button type="button" onClick={() => setCurrentStep(1)}>
              Back
            </Button>
            <Button type="submit">Submit</Button>
          </>
        )}
      </form>
    </Container>
  );
};

export default FreshPassport;

// Styled Components

const Progress = styled.div`
  margin-bottom: 1rem;
  font-weight: bold;
`;

// Animations and styling
const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  } 
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const Container = styled.div`
  max-width: 700px;
  margin: 2rem auto;
  padding: 2rem;
  background: linear-gradient(145deg, #0d0d0d, #1a1a1a);
  color: #e6e6e6;
  border: 1px solid #353535;
  border-radius: 8px;
`;

const Input = styled.input`
  width: 100%;
  padding: 0.75rem;
  margin-bottom: 1rem;
  background: transparent;
  border: 1px solid #444;
  border-radius: 4px;
  color: white;
  &:focus {
    border-color: #3f51ff;
    outline: none;
  }
`;

const Label = styled.label`
  margin-bottom: 0.5rem;
  display: block;
`;

const Button = styled.button`
  padding: 0.75rem 1.5rem;
  margin: 0.5rem;
  background: linear-gradient(90deg, #194bfd, #ad13fb);
  border: none;
  border-radius: 4px;
  color: white;
  cursor: pointer;
`;
